import React, {
  ReactElement,
  useEffect,
  useState,
} from 'react';
import {Entity} from '../../../types/entities/Entity';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {Checkbox, Chip, List, Stack, Switch, TextField, Typography} from '@mui/material';
import {ContactMailRounded} from "@mui/icons-material";
import Box from "@mui/material/Box";
import whatsapp from '../../../assets/icons/whatsapp.svg';

type Props<T extends Entity> = {
  item: any;
  index: number;
  readonly?: boolean;
  onSubmit: () => void;
  onChangeCheck: (id: any, value: any) => void;
  onChangeMessage: (id: string | number, text: string) => void;
};

export const SendModificationListItem = <T extends Entity>({
                                                             item,
                                                             index,
                                                             onChangeCheck,
                                                             onChangeMessage,
                                                             onSubmit,
                                                             readonly,
                                                           }: Props<T>): ReactElement => {
  const [checked, setChecked] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {

    const newChecked: { [key: string]: boolean } = {};
    item.modifications.forEach((modification: any) => {
      if (modification.id) {
        newChecked[modification.id] = true;
      }
    });

    setChecked(newChecked);

  }, []);


  return (
    <>
      <ListItem
        key={index}
        secondaryAction={<></>}
        disablePadding
        sx={{
          background: '#f3f3f3',
          borderRadius: '10px',
          marginTop: '10px',
        }}
      >
        <ListItem
          sx={{
            padding: '10px',
          }}
        >
          <ListItemText
            primary={
              <React.Fragment>
                <Stack
                  direction={'row'}
                  gap={1}
                  alignItems={'center'}
                  sx={{
                    marginBottom: '10px',
                  }}
                >
                  {item?.service_provider?.whatsapp ? (
                    <Box sx={{
                      width: "30px"
                    }}>
                      <img src={whatsapp} alt="Whatsapp" />
                    </Box>
                  ) : (
                    <ContactMailRounded color={'primary'} />
                  )}

                  <Typography sx={{ fontWeight: 'bold' }}>
                    {item?.service_provider?.name}:
                  </Typography>
                  <Stack gap={1} direction={'row'} flexWrap={'wrap'} alignItems={'flex-start'}>
                    {item.contacts.map((contact: any) => {
                      return (
                        <Chip label={<>
                          <Stack direction={'row'} gap={1}>
                            <Typography sx={{fontWeight: 'bold'}}>
                              {contact?.name}
                            </Typography>
                            <Typography color={'#666'}>
                              ({item?.service_provider?.whatsapp?contact?.phone:contact?.email})
                            </Typography>
                          </Stack>
                        </>}/>
                      );
                    })}
                  </Stack>
                </Stack>
              </React.Fragment>
            }
            secondary={
              <React.Fragment>
                {item.modifications.map((providerModifications:any, providerModificationsIndex:any)=>{

                    return (
                      <>
                        <List
                          sx={{
                            background: '#fff',
                            borderRadius: '8px',
                            marginBottom: '8px',
                            borderBottom: '1px solid #e7e7e7',
                          }}
                        >
                          <ListItem
                            key={providerModificationsIndex}
                            sx={{
                              paddingTop: '0px',
                              paddingBottom: '0px',
                            }}
                          >
                            <ListItemText
                              primary={
                                <React.Fragment>
                                  <Stack gap={1}>
                                    <Stack
                                      direction={'row'}
                                      alignItems={'center'}
                                      gap={1}
                                    >
                                      <div
                                        className={
                                          'flex items-center justify-between w-full'
                                        }
                                      >
                                        <Stack gap={1}>
                                          {item?.contact_has_more_provider && (
                                            <>
                                              <Stack
                                                direction={'row'}
                                                alignItems={'center'}
                                                gap={1}
                                              >
                                                <Typography>
                                                  Szolgáltató:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 'bold' }}
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      item?.service_provider
                                                        ?.name,
                                                  }}
                                                ></Typography>
                                              </Stack>
                                            </>
                                          )}

                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>Típus:</Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                providerModifications
                                                  ?.value?.type,
                                              }}
                                            ></Typography>
                                          </Stack>
                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>
                                              Szobák:
                                            </Typography>
                                            <Typography>
                                              <Stack gap={0}>
                                              {providerModifications
                                                ?.value.rooms.map((item:any)=>{
                                                  return <Typography sx={{ fontWeight: 'bold' }}>{item?.room_type} – {item?.quantity} db</Typography>;
                                                })}
                                              </Stack>
                                            </Typography>
                                          </Stack>
                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>
                                              Érkezés dátuma:
                                            </Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                providerModifications
                                                  ?.value?.arrival,
                                              }}
                                            ></Typography>
                                          </Stack>
                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>
                                              Távozás dátuma:
                                            </Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                providerModifications
                                                  ?.value?.departure,
                                              }}
                                            ></Typography>
                                          </Stack>
                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>
                                              Csoport:
                                            </Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                providerModifications
                                                  ?.value?.group,
                                              }}
                                            ></Typography>
                                          </Stack>
                                          <Stack
                                            direction={'row'}
                                            alignItems={'center'}
                                            gap={1}
                                          >
                                            <Typography>
                                              Létszám:
                                            </Typography>
                                            <Typography
                                              sx={{ fontWeight: 'bold' }}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                providerModifications
                                                  ?.value?.size,
                                              }}
                                            ></Typography>
                                          </Stack>

                                          {(providerModifications?.value?.custom_fields && providerModifications?.value?.custom_fields.length ) ? (
                                            <>
                                              {providerModifications.value.custom_fields.map(
                                                (customField: any) => {
                                                  return (
                                                    <Stack
                                                      direction={'row'}
                                                      alignItems={'center'}
                                                      gap={1}
                                                    >
                                                      <Typography>
                                                        {
                                                          customField?.column
                                                            ?.name
                                                        }
                                                        :
                                                      </Typography>
                                                      {(customField?.column
                                                          ?.type === 'float' ||
                                                        customField?.column
                                                          ?.type ===
                                                        'string') && (
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 'bold',
                                                          }}
                                                        >
                                                          {customField?.value}
                                                        </Typography>
                                                      )}
                                                      {customField?.column
                                                        ?.type === 'boolean' && (
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 'bold',
                                                          }}
                                                        >
                                                          <Checkbox
                                                            sx={{
                                                              pointerEvents:
                                                                'none',
                                                            }}
                                                            defaultChecked={
                                                              customField?.value
                                                            }
                                                          />
                                                        </Typography>
                                                      )}
                                                      {customField?.column
                                                        ?.type === 'text' && (
                                                        <Typography>
                                                          <Box
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                              customField?.value,
                                                            }}
                                                          ></Box>
                                                        </Typography>
                                                      )}
                                                      {customField?.column
                                                        ?.type === 'driver' && (
                                                        <Typography
                                                          sx={{
                                                            fontWeight: 'bold',
                                                          }}
                                                        >
                                                          {
                                                            customField?.value
                                                              ?.name
                                                          }
                                                        </Typography>
                                                      )}
                                                    </Stack>
                                                  );
                                                }
                                              )}
                                            </>
                                          ):(
                                            <>
                                            </>
                                          )}

                                        </Stack>
                                      </div>
                                      {readonly ? (
                                       <></>
                                      ) : (
                                        <Switch
                                          checked={checked[`${providerModifications?.id}`]}
                                          onChange={(event, checkedRow) => {
                                            setChecked({...checked,[`${providerModifications?.id}`]: checkedRow });
                                            onChangeCheck(providerModifications?.id, checkedRow);
                                          }}
                                        />
                                      )}
                                    </Stack>
                                    <Box>
                                      <TextField
                                        fullWidth
                                        label="Message to Provider"
                                        multiline
                                        maxRows={4}
                                        onChange={(e) => onChangeMessage(providerModifications?.id, e.target.value)}
                                      />
                                    </Box>
                                  </Stack>
                                </React.Fragment>
                              }
                            />
                          </ListItem>
                        </List>
                      </>
                    );
                  }
                )}
              </React.Fragment>
            }
          />
        </ListItem>
      </ListItem>
    </>
  );
};